<template>
  <div class="row">
    <div class="col-md-1">
      <img
        src="@/assets/images/ic-arrow-left.svg"
        width="30"
        class="arrow mb-30"
        alt
        @click="changeComponent('Details')"
      />
    </div>
    <div class="col-md-11">
      <h2 class="header-title">Change Name</h2>
      <div class="row mt-30">
        <div class="col-md-6">
          <b-form @submit="changeName">
            <b-form-group
              id="firstname-fieldset"
              label="First Name"
              label-for="firstname"
              :invalid-feedback="invalidFeedback('firstname')"
              :state="state('firstname')"
            >
              <b-form-input
                id="firstname"
                v-model="form.firstname"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="lastname-fieldset"
              label="Last Name"
              label-for="lastname"
              :invalid-feedback="invalidFeedback('lastname')"
              :state="state('lastname')"
            >
              <b-form-input
                id="lastname"
                v-model="form.lastname"
                required
              ></b-form-input>
            </b-form-group>
            <b-button
              type="submit"
              class="btn btn-core fw mt-10"
              :disabled="
                authIsLoading || merchantIsLoading || customerIsLoading
              "
              v-if="webDesign !== null && webDesign.design !== null"
              :style="{ 
                backgroundColor: webDesign.design.main_color+'!important',
                border: 'none !important',
                color: webDesign.design.button_text_color+'!important'
              }"
            >
              SAVE CHANGES
            </b-button>
            <b-button
              type="submit"
              class="btn btn-core fw mt-10"
              :disabled="
                authIsLoading || merchantIsLoading || customerIsLoading
              "
              v-else
            >
              SAVE CHANGES
            </b-button>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      form: {
        firstname: "",
        lastname: ""
      }
    };
  },
  computed: {
    ...mapState("auth", {
      token: state => state.token,
      authErrors: state => state.errors,
      authIsLoading: state => state.loading
    }),
    ...mapState("customer", {
      customer: state => state.user,
      customerErrors: state => state.errors,
      customerIsLoading: state => state.loading
    }),
    ...mapState("merchant", {
      subdomain: state => state.subdomain,
      customerPortalToken: state => state.customerPortalToken,
      merchantIsLoading: state => state.loading,
      merchantErrors: state => state.errors,
      merchantSettings: state => state.merchantSettings
    }),
    ...mapState("estore", {
      webDesign: state => state.webDesign
    }),
  },
  created: function() {
    this.form.firstname = this.customer.firstname;
    this.form.lastname = this.customer.lastname;
  },
  methods: {
    changeComponent(component) {
      this.$emit("change-component", component);
      this.$emit("change-title", "Name Updated!");
    },
    changeName: async function(evt) {
      evt.preventDefault();
      this.$store.dispatch("auth/resetErrors");
      this.$store.dispatch("customer/resetErrors");
      let request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken
        },
        payload: {
          firstname: this.form.firstname,
          lastname: this.form.lastname
        }
      };

      let _this = this;
      await this.$store
        .dispatch("customer/updateCustomerName", request)
        .then(() => {
          if (_this.customerErrors == null) {
            _this.changeComponent("Success");
          }
        });
    },
    invalidFeedback(field) {
      if (field == "mobile") {
        field = "mobile_number";
      }
      if (this.customerErrors == null) {
        return "";
      }
      return this.customerErrors.errors[field];
    },
    state(field) {
      if (this.customerErrors == null) {
        return false;
      }
      return this.customerErrors.errors[field] ? false : true;
    }
  }
};
</script>
